webpackJsonp([1],Array(27).concat([
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(136),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e0667266",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return replaceAccents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mobileTap; });
var replaceAccents = function replaceAccents(str) {
  var replacedStr = str.replace(/[ăâ]/g, 'a').replace(/[ĂÂ]/g, 'A').replace(/[î]/g, 'i').replace(/[Î]/g, 'I').replace(/[ș]/g, 's').replace(/[Ș]/g, 'S').replace(/[ț]/g, 't').replace(/[Ț]/g, 'T');
  return replacedStr;
};

var mobileTap = function mobileTap(mq, cb) {
  var tapMQ = window.matchMedia('(max-width: ' + mq + 'px)');
  if (tapMQ.matches) cb();
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Landing__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Beginning__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Beginning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Beginning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_End__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_End___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_End__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Poem__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Poem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Poem__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);






/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Landing___default.a
  }, {
    path: '/beginning',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Beginning___default.a
  }, {
    path: '/end',
    component: __WEBPACK_IMPORTED_MODULE_4__components_End___default.a
  }, {
    path: '/:nr-:title',
    name: 'Poem',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Poem___default.a,
    props: true
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Landing___default.a
  }]
}));

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(140);





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var contentVersion = 3;
if (+localStorage.getItem('contentVersion') !== contentVersion && navigator.onLine) {
  localStorage.removeItem('folderListDownloaded');
  localStorage.removeItem('poemsDownloaded');
}
var sidebarLeftToggled = localStorage.getItem('sidebarLeftToggled') === 'true' || false;
var sidebarRightToggled = localStorage.getItem('sidebarRightToggled') === 'true' || false;
var selectedTheme = +localStorage.getItem('selectedTheme') || 0;
var selectedFontSize = +localStorage.getItem('selectedFontSize') || 1;
var folderListDownloaded = localStorage.getItem('folderListDownloaded') === 'true' || false;
var poemsDownloaded = localStorage.getItem('poemsDownloaded') === 'true' || false;
var searchText = localStorage.getItem('searchText') || '';
var filtersOpen = localStorage.getItem('filtersOpen') === 'true' || false;
var checkedFilters = JSON.parse(localStorage.getItem('checkedFilters')) || ['checkboxTitle', 'checkboxVerses', 'checkboxWhole', 'checkboxCase', 'checkboxAccents', 'checkboxPunctuation'];

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    contentVersion: contentVersion,
    sidebarLeftToggled: sidebarLeftToggled,
    sidebarRightToggled: sidebarRightToggled,
    selectedTheme: selectedTheme,
    selectedFontSize: selectedFontSize,
    folderListDownloaded: folderListDownloaded,
    selectedPoem: {},
    selectEnabled: false,
    copyConfirmShown: false,
    moreOpen: false,
    fullBook: poemsDownloaded,
    poemsDownloaded: poemsDownloaded,
    searchFocused: false,
    searchText: searchText,
    filtersOpen: filtersOpen,
    checkedFilters: checkedFilters
  },
  mutations: {
    toggleSidebarLeft: function toggleSidebarLeft(state) {
      var scrollLinkIntoView = function scrollLinkIntoView() {
        var route = document.querySelector('.router-link-active');
        var routeParent = route.parentElement.parentElement.firstElementChild;
        if (routeParent && !routeParent.checked) routeParent.click();
        route.scrollIntoView();
      };
      var waitForToggle = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        state.sidebarLeftToggled = !state.sidebarLeftToggled;
        resolve();
      });
      waitForToggle.then(function () {
        if (state.sidebarLeftToggled) {
          if (!state.folderListDownloaded) {
            var waitForLoad = setInterval(function () {
              if (state.folderListDownloaded) {
                clearInterval(waitForLoad);
                scrollLinkIntoView();
              }
            }, 100);
          } else scrollLinkIntoView();
        }
      });
      localStorage.setItem('sidebarLeftToggled', state.sidebarLeftToggled);
    },
    toggleSidebarRight: function toggleSidebarRight(state) {
      state.sidebarRightToggled = !state.sidebarRightToggled;
      localStorage.setItem('sidebarRightToggled', state.sidebarRightToggled);
    },
    closeSidebars: function closeSidebars(state) {
      state.sidebarLeftToggled = false;
      localStorage.setItem('sidebarLeftToggled', false);
      state.sidebarRightToggled = false;
      localStorage.setItem('sidebarRightToggled', false);
    },
    setSelectedTheme: function setSelectedTheme(state, theme) {
      state.selectedTheme = theme;
      localStorage.setItem('selectedTheme', theme);
    },
    zoomReset: function zoomReset(state) {
      state.selectedFontSize = 1;
      localStorage.setItem('selectedFontSize', 1);
    },
    zoomOut: function zoomOut(state) {
      if (state.selectedFontSize > 0.7) {
        state.selectedFontSize -= 0.06;
        localStorage.setItem('selectedFontSize', state.selectedFontSize);
      }
    },
    zoomIn: function zoomIn(state) {
      if (state.selectedFontSize < 1.3) {
        state.selectedFontSize += 0.06;
        localStorage.setItem('selectedFontSize', state.selectedFontSize);
      }
    },
    setFolderListDownloaded: function setFolderListDownloaded(state) {
      state.folderListDownloaded = true;
      localStorage.setItem('folderListDownloaded', true);
      localStorage.setItem('contentVersion', state.contentVersion);
    },
    setSelectedPoem: function setSelectedPoem(state, poem) {
      state.selectedPoem = poem;
    },
    setSelectEnabled: function setSelectEnabled(state, boolean) {
      state.selectEnabled = boolean;
    },
    toggleCopyConfirm: function toggleCopyConfirm(state) {
      state.copyConfirmShown = true;
      setTimeout(function () {
        state.copyConfirmShown = false;
      }, 3000);
    },
    toggleMore: function toggleMore(state) {
      state.moreOpen = !state.moreOpen;
    },
    setFullBook: function setFullBook(state) {
      state.fullBook = true;
    },
    setPoemsDownloaded: function setPoemsDownloaded(state) {
      state.poemsDownloaded = true;
      localStorage.setItem('poemsDownloaded', true);
    },
    handleSearchFocus: function handleSearchFocus(state, bool) {
      state.searchFocused = bool;
    },
    setSearchText: function setSearchText(state, str) {
      localStorage.setItem('searchText', str);
    },
    toggleFilters: function toggleFilters(state) {
      state.filtersOpen = !state.filtersOpen;
      localStorage.setItem('filtersOpen', state.filtersOpen);
    },
    setCheckedFilters: function setCheckedFilters(state, array) {
      state.checkedFilters = array;
      localStorage.setItem('checkedFilters', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(array));
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__(45);






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* store */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb_keyval__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb_keyval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idb_keyval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SidebarLeft__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SidebarLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SidebarLeft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SidebarRight__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SidebarRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SidebarRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_More__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_More___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_More__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar___default.a,
    SidebarLeft: __WEBPACK_IMPORTED_MODULE_2__components_SidebarLeft___default.a,
    SidebarRight: __WEBPACK_IMPORTED_MODULE_3__components_SidebarRight___default.a,
    More: __WEBPACK_IMPORTED_MODULE_4__components_More___default.a
  },
  data: function data() {
    return {
      folderListSnap: null,
      poemsSnap: null,
      selectedPoem: null,
      themes: [{
        theme: '#ecce93',
        accent: '#ecce93',
        text: '#212121',
        text2: '#757575',
        text3: '#212121',
        border: '#ecce93',
        border2: '#e1e1e1',
        border3: '#e1e1e1',
        background: '#fff',
        backdrop: '#fff',
        navbar: '#fff',
        logo: '#ecce93',
        icon: '#212121',
        icon2: '#212121',
        confirm: '#FFFF00',
        confirm2: '#757575',
        rule: '#e6e6e6',
        highlight: '#f7ebd4'
      }, {
        theme: '#ecce93',
        accent: '#ecce93',
        text: '#fff',
        text2: '#dedede',
        text3: '#fff',
        border: '#ecce93',
        border2: '#675d4c',
        border3: '#675d4c',
        background: '#212121',
        backdrop: '#212121',
        navbar: '#212121',
        logo: '#fff',
        icon: '#fff',
        icon2: '#fff',
        confirm: '#C6FF00',
        confirm2: '#212121',
        rule: '#333',
        highlight: '#675d48'
      }, {
        theme: '#393a3e',
        accent: '#ff764b',
        text: '#393a3e',
        text2: '#757575',
        text3: '#dedede',
        border: '#393a3e',
        border2: '#605c52',
        border3: '#beb6a7',
        background: '#fff4d7',
        backdrop: '#fff4d7',
        navbar: '#393a3e',
        logo: '#fff',
        icon: '#fff',
        icon2: '#757575',
        confirm: '#18FFFF',
        confirm2: '#757575',
        rule: '#eee0ba',
        highlight: '#ffc8a6'
      }]
    };
  },
  created: function created() {
    var _this = this;

    var selectedTheme = this.themes[this.$store.state.selectedTheme];
    var metaThemeColor = document.querySelector('meta[name=theme-color]');
    metaThemeColor.setAttribute('content', selectedTheme.theme);
    document.body.style.setProperty('--themeBG', selectedTheme.background);
    if (this.$store.state.sidebarRightToggled || this.$store.state.poemsDownloaded) this.getPoemsSnap(this.fetchPoem);else if (this.$store.state.route.params.nr) this.fetchPoem();
    if (this.$store.state.folderListDownloaded) {
      __WEBPACK_IMPORTED_MODULE_0_idb_keyval___default.a.keys().then(function (keys) {
        var folderListDeleted = !keys.includes('folderList');
        var poemsDeleted = _this.$store.state.poemsDownloaded && !keys.includes('poems');
        if (folderListDeleted) localStorage.removeItem('folderListDownloaded');
        if (poemsDeleted) localStorage.removeItem('poemsDownloaded');
        if (folderListDeleted || poemsDeleted) window.location.reload();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$store.state.sidebarLeftToggled || this.$store.state.folderListDownloaded) this.getFolderListSnap();
    var lastRoute = localStorage.getItem('lastRoute');
    if (lastRoute && !this.currentNr) {
      this.$router.push(lastRoute);
      if (this.$store.state.sidebarLeftToggled) {
        var waitForLoad = setInterval(function () {
          var lastRouteById = document.getElementById('' + _this2.$store.state.route.params.nr);
          if (lastRouteById) {
            clearInterval(waitForLoad);
            lastRouteById.parentElement.parentElement.firstElementChild.click();
            lastRouteById.scrollIntoView();
          }
        }, 100);
      }
    }
  },

  computed: {
    selectedTheme: function selectedTheme() {
      return this.themes[this.$store.state.selectedTheme];
    },
    currentNr: function currentNr() {
      return this.$store.state.route.params.nr;
    }
  },
  methods: {
    closeSidebars: function closeSidebars() {
      this.$store.commit('closeSidebars');
    },
    toggleMore: function toggleMore() {
      this.$store.commit('toggleMore');
    },
    DBURL: function DBURL(file) {
      return '/static/json/' + file + '.json';
    },
    logError: function logError(msg) {
      console.log(msg);
    },
    loadFolderList: function loadFolderList() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_idb_keyval___default.a.get('folderList').then(function (val) {
        _this3.folderListSnap = val;
      });
    },
    getFolderListSnap: function getFolderListSnap() {
      var _this4 = this;

      if (!this.$store.state.folderListDownloaded) {
        fetch(this.DBURL('cuprins')).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this4.folderListSnap = data;

          __WEBPACK_IMPORTED_MODULE_0_idb_keyval___default.a.set('folderList', data).then(function () {
            _this4.$store.commit('setFolderListDownloaded');
          }).catch(function (err) {
            _this4.logError('Folder List Saving Failed:' + err);
          });
        }).catch(function (err) {
          _this4.logError('Downloading Folder List Failed:' + err);
        });
      } else this.loadFolderList();
    },
    fetchPoem: function fetchPoem() {
      var _this5 = this;

      if (this.currentNr) {
        if (this.poemsSnap) this.selectedPoem = this.poemsSnap[this.currentNr - 1];else {
          fetch(this.DBURL('poezii/' + this.currentNr)).then(function (response) {
            return response.json();
          }).then(function (data) {
            _this5.selectedPoem = data;
          }).catch(function (err) {
            _this5.logError('Fetching Poem No.' + _this5.currentNr + ' Failed:' + err);
          });
        }
      }
    },
    loadPoems: function loadPoems(cb) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_idb_keyval___default.a.get('poems').then(function (val) {
        _this6.poemsSnap = val;

        if (cb) {
          cb();
        }
      });
    },
    getPoemsSnap: function getPoemsSnap(cb) {
      var _this7 = this;

      if (!this.$store.state.poemsDownloaded) {
        fetch(this.DBURL('poezii')).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this7.poemsSnap = data;

          if (cb) {
            cb();
          }
          __WEBPACK_IMPORTED_MODULE_0_idb_keyval___default.a.set('poems', data).then(function () {
            _this7.$store.commit('setPoemsDownloaded');
          }).catch(function (err) {
            _this7.logError('Poems Saving Failed:' + err);
          });
        }).catch(function (err) {
          _this7.logError('Downloading Poems Failed:' + err);
        });
      } else this.loadPoems(cb);
      if (!this.$store.state.folderListDownloaded) this.getFolderListSnap();
    }
  },
  watch: {
    '$route': function $route() {
      this.fetchPoem();
      localStorage.setItem('lastRoute', this.$store.state.route.path);
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'beginning',
  props: ['theme'],
  created: function created() {
    window.addEventListener('keyup', this.handleArrowRight);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.handleArrowRight);
  },

  methods: {
    goBack: function goBack() {
      this.$router.back();
    },
    handleArrowRight: function handleArrowRight(e) {
      if (e.key === 'ArrowRight' && !this.$store.state.searchFocused) {
        this.goBack();
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'end',
  props: ['theme'],
  created: function created() {
    window.addEventListener('keyup', this.handleArrowLeft);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.handleArrowLeft);
  },

  methods: {
    goBack: function goBack() {
      this.$router.back();
    },
    handleArrowLeft: function handleArrowLeft(e) {
      if (e.key === 'ArrowLeft' && !this.$store.state.searchFocused) {
        this.goBack();
      }
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  props: ['theme'],
  data: function data() {
    return {
      listButtonHovered: false,
      searchButtonHovered: false
    };
  },

  methods: {
    toggleSidebarLeft: function toggleSidebarLeft() {
      this.$store.commit('toggleSidebarLeft');
      if (!this.$store.state.folderListDownloaded) this.$emit('downloadFolderList');
    },
    toggleSidebarRight: function toggleSidebarRight() {
      this.$store.commit('toggleSidebarRight');
      this.$store.commit('setFullBook');
      if (!this.$store.state.poemsDownloaded) this.$emit('downloadPoems');
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wrapper',
  props: ['color']
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  props: ['theme']
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemePicker__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ThemePicker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  props: ['theme', 'themes'],
  components: {
    ThemePicker: __WEBPACK_IMPORTED_MODULE_0__ThemePicker___default.a
  },
  data: function data() {
    return {
      themePickerToggled: false
    };
  },

  methods: {
    toggleSidebarLeft: function toggleSidebarLeft() {
      this.$store.commit('toggleSidebarLeft');
      if (!this.$store.state.folderListDownloaded) this.$emit('downloadFolderList');
    },
    toggleSidebarRight: function toggleSidebarRight() {
      this.$store.commit('toggleSidebarRight');
      this.$store.commit('setFullBook');
      if (!this.$store.state.poemsDownloaded) this.$emit('downloadPoems');
    },
    toggleThemePicker: function toggleThemePicker() {
      this.themePickerToggled = !this.themePickerToggled;
    },
    closeThemePicker: function closeThemePicker() {
      this.themePickerToggled = false;
    },
    toggleMore: function toggleMore() {
      this.$store.commit('toggleMore');
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loading__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'poem',
  props: ['theme', 'nr', 'selectedPoem'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__Loading___default.a
  },
  data: function data() {
    return {
      zoomMenuOpen: false,
      poemTransitionName: '',
      currentURL: '',
      navigatorHasShare: typeof navigator !== 'undefined' && navigator.share
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.currentURL = location.href;
    var clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a('#btnCopy');
    clipboard.on('success', function (e) {
      e.clearSelection();
      _this.$store.commit('setSelectEnabled', false);
      _this.$store.commit('toggleCopyConfirm');
    });
    clipboard.on('error', function (e) {
      _this.$store.commit('setSelectEnabled', false);
    });
  },
  created: function created() {
    window.addEventListener('keyup', this.handlePoemKeyNav);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.handlePoemKeyNav);
  },

  computed: {
    fontSizeREM: function fontSizeREM() {
      return this.$store.state.selectedFontSize + 'rem';
    }
  },
  methods: {
    checkFolder: function checkFolder(poemLink) {
      var routeParent = poemLink.parentElement.parentElement.firstElementChild;
      if (routeParent && !routeParent.checked) routeParent.click();
    },
    prevPoem: function prevPoem() {
      var currentNr = +document.querySelector('.router-link-active').id;
      var prevRoute = document.getElementById('' + (currentNr - 1));
      if (prevRoute) {
        this.checkFolder(prevRoute);
        prevRoute.click();
        prevRoute.scrollIntoView();
      } else this.$router.push('beginning');
    },
    nextPoem: function nextPoem() {
      var currentNr = +document.querySelector('.router-link-active').id;
      var nextRoute = document.getElementById('' + (currentNr + 1));
      if (nextRoute) {
        nextRoute.click();
        this.checkFolder(nextRoute);
        nextRoute.scrollIntoView();
      } else this.$router.push('end');
    },
    handlePoemKeyNav: function handlePoemKeyNav(e) {
      var searchFocused = this.$store.state.searchFocused;
      if (e.key === 'ArrowLeft' && !searchFocused) {
        this.prevPoem();
      } else if (e.key === 'ArrowRight' && !searchFocused) {
        this.nextPoem();
      }
    },
    toggleZoomMenu: function toggleZoomMenu() {
      this.zoomMenuOpen = !this.zoomMenuOpen;
    },
    zoomReset: function zoomReset() {
      this.$store.commit('zoomReset');
    },
    zoomOut: function zoomOut() {
      this.$store.commit('zoomOut');
    },
    zoomIn: function zoomIn() {
      this.$store.commit('zoomIn');
    },
    toggleShareMenu: function toggleShareMenu() {
      navigator.share({
        title: this.selectedPoem.t,
        text: this.selectedPoem.s,
        url: this.currentURL
      }).catch(function (error) {
        return error;
      });
    },
    enableSelect: function enableSelect() {
      this.$store.commit('setSelectEnabled', true);
    },
    afterLeave: function afterLeave() {
      document.getElementById('poemParent').scrollTop = 0;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      var toDepth = to.params.nr;
      var fromDepth = from.params.nr;
      this.poemTransitionName = toDepth < fromDepth ? 'slide-right-poem' : 'slide-left-poem';
      this.currentURL = location.href;
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loading__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar-left',
  props: ['theme', 'folderListSnap'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__Loading___default.a
  },
  methods: {
    formatTitle: function formatTitle(title) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* replaceAccents */])(title).replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/-+/g, '-');
    },
    toggleSidebarLeft: function toggleSidebarLeft() {
      this.$store.commit('toggleSidebarLeft');
    },
    handleFolderClick: function handleFolderClick(folder) {
      var folderById = document.getElementById(folder);
      if (folderById.checked) setTimeout(function () {
        folderById.checked = false;
      }, 0);else setTimeout(function () {
        folderById.nextElementSibling.scrollIntoView();
      }, 0);
    },
    tapPoemLink: function tapPoemLink() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* mobileTap */])(1100, this.toggleSidebarLeft);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loading__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar-right',
  props: ['theme', 'poemsSnap'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__Loading___default.a
  },
  data: function data() {
    return {
      checkedFilters: this.$store.state.checkedFilters,
      searchText: this.$store.state.searchText,
      results: [],
      resultsCounter: 0,
      resultsPoemsCounter: 0,
      resultsInfoShown: false,
      lastSelectedResult: ''
    };
  },

  computed: {
    resultsInfo: function resultsInfo() {
      if (!this.resultsInfoShown) return;
      var inPoems = ' ';
      if (this.resultsCounter) {
        inPoems = ' \xEEn ' + this.resultsPoemsCounter + ' ' + (this.resultsPoemsCounter === 1 ? 'poezie' : 'poezii') + ' ';
      }
      return this.resultsCounter + ' ' + (this.resultsCounter === 1 ? 'rezultat' : 'rezultate') + inPoems + 'pentru "' + this.searchText + '"';
    }
  },
  methods: {
    toggleSidebarRight: function toggleSidebarRight() {
      this.$store.commit('toggleSidebarRight');
    },
    handleSearchFocus: function handleSearchFocus(bool) {
      this.$store.commit('handleSearchFocus', bool);
    },
    focusSearch: function focusSearch() {
      document.getElementById('searchInput').focus();
    },
    toggleFilters: function toggleFilters() {
      this.$store.commit('toggleFilters');
    },
    handleCheckTitle: function handleCheckTitle(e) {
      if (this.checkedFilters.includes('checkboxTitle') && !this.checkedFilters.includes('checkboxVerses')) {
        e.preventDefault();
      }
    },
    handleCheckVerses: function handleCheckVerses(e) {
      if (this.checkedFilters.includes('checkboxVerses') && !this.checkedFilters.includes('checkboxTitle')) {
        e.preventDefault();
      }
    },
    submitSearch: function submitSearch() {
      var _this = this;

      if (this.searchText.length > 2) {
        document.getElementById('sidebarRightResults').scrollTop = 0;
        this.results = [];
        var searchInTitle = this.checkedFilters.includes('checkboxTitle');
        var searchInVerses = this.checkedFilters.includes('checkboxVerses');
        var searchWhole = this.checkedFilters.includes('checkboxWhole');
        var searchIgnoreCase = this.checkedFilters.includes('checkboxCase');
        var searchIgnoreAccents = this.checkedFilters.includes('checkboxAccents');
        var searchIgnorePunctuation = this.checkedFilters.includes('checkboxPunctuation');
        this.resultsCounter = 0;
        this.resultsPoemsCounter = 0;
        var textToSearch = this.searchText.replace(/\s\s+/g, ' ').trim();
        if (searchIgnoreAccents) {
          textToSearch = textToSearch.replace(/[aăâ]/g, '[aăâ]').replace(/[AĂÂ]/g, '[AĂÂ]').replace(/[iî]/g, '[iî]').replace(/[IÎ]/g, '[IÎ]').replace(/[sș]/g, '[sș]').replace(/[SȘ]/g, '[SȘ]').replace(/[tț]/g, '[tț]').replace(/[TȚ]/g, '[TȚ]');
        }
        if (searchIgnorePunctuation) {
          textToSearch = textToSearch.replace(/[!?,.]/g, '').replace(/\s/g, '[!?,.\\s]+?');
        }
        var searchRegEx = void 0;
        var searchFlags = 'g';
        if (searchIgnoreCase) searchFlags = 'ig';
        if (searchWhole) {
          var searchWholeRegExChars = 'a-zA-ZăâîșțĂÂÎȘȚ';
          searchRegEx = new RegExp('([^' + searchWholeRegExChars + ']|^)(' + textToSearch + ')(?![' + searchWholeRegExChars + '])', searchFlags);
        } else searchRegEx = new RegExp(textToSearch, searchFlags);
        var incrementResultsCounter = function incrementResultsCounter(int) {
          _this.resultsCounter += int;
        };
        var searchForMatches = function searchForMatches(textToBeSearched) {
          var matchesCount = (textToBeSearched.match(searchRegEx) || []).length;
          if (matchesCount) incrementResultsCounter(matchesCount);
          return matchesCount;
        };
        var highlightMatches = function highlightMatches(textToBeHighlighted) {
          var firstGroup = '';
          var secondGroup = '$&';
          if (searchWhole) {
            firstGroup = '$1';
            secondGroup = '$2';
          }
          return textToBeHighlighted.replace(searchRegEx, firstGroup + '<span style="background-color: ' + _this.theme.highlight + '">' + secondGroup + '</span>');
        };
        var listVersesMatches = function listVersesMatches(results) {
          var matchRegEx = /((?:\S+\s){0,3})\S*<span([^]*?)<\/span>\S*((?:\s\S+){0,3})/g;
          var list = [];
          var match = void 0;
          while ((match = matchRegEx.exec(results)) !== null) {
            list.push(match[0]);
          }
          return list;
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.poemsSnap.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var index = _ref2[0];
            var item = _ref2[1];

            var title = item.t;
            var verses = null;
            var titleResults = null;
            var versesResults = null;
            if (searchInTitle) titleResults = searchForMatches(item.t);
            if (searchInVerses) versesResults = searchForMatches(item.s);
            if (titleResults) title = highlightMatches(item.t);
            if (versesResults) {
              verses = listVersesMatches(highlightMatches(item.s));
            }
            if (titleResults || versesResults) {
              this.results.push({
                nr: index + 1,
                title: title,
                verses: verses
              });
              this.resultsPoemsCounter += 1;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.lastSelectedResult = 0;
        this.$store.commit('setSearchText', this.searchText);
        setTimeout(function () {
          _this.resultsInfoShown = true;
        });
      }
    },
    handleResultClick: function handleResultClick(event, nr) {
      var route = document.getElementById(nr);
      var routeParent = route.parentElement.parentElement.firstElementChild;
      if (!routeParent.checked) routeParent.click();
      route.click();
      route.scrollIntoView();
      if (this.lastSelectedResult.length) {
        document.getElementById(this.lastSelectedResult).classList.remove('active');
      }
      event.target.closest('.result').classList.add('active');
      this.lastSelectedResult = 'res' + nr;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* mobileTap */])(1100, this.toggleSidebarRight);
    }
  },
  watch: {
    checkedFilters: function checkedFilters() {
      this.$store.commit('setCheckedFilters', this.checkedFilters);
    },
    searchText: function searchText() {
      this.resultsInfoShown = false;
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'theme-picker',
  props: ['themes'],
  methods: {
    setSelectedTheme: function setSelectedTheme(themeIndex) {
      this.$store.commit('setSelectedTheme', themeIndex);
      var selectedTheme = this.themes[this.$store.state.selectedTheme];
      document.querySelector('meta[name=theme-color]').setAttribute('content', selectedTheme.theme);
      document.body.style.setProperty('--themeBG', selectedTheme.background);
    }
  }
});

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traian-dorz.c6644cf.jpg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(130),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(135),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-897b8bb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-138955d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(137),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f672dae2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(128),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-182097a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(129),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2daa5714",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(132),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7634b542",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(134),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9c258970",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more",
    style: ({
      backgroundColor: _vm.theme.background,
      borderColor: _vm.theme.border2
    })
  }, [_c('div', [_c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Ion Lupița")])]), _vm._v(" "), _c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconList"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Andrei Roman")])]), _vm._v(" "), _c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("&")]), _vm._v(" "), _c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Daniel Pintilei")])]), _vm._v(" "), _c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Netlify")])])])])
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "poem",
    attrs: {
      "id": "poemParent"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.poemTransitionName,
      "mode": "out-in"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('article', {
    key: _vm.nr,
    staticClass: "poem__main",
    class: {
      select: _vm.$store.state.selectEnabled
    },
    style: ({
      fontSize: _vm.fontSizeREM
    }),
    attrs: {
      "id": "poem"
    }
  }, [(_vm.selectedPoem) ? [_c('h1', {
    staticClass: "poem__title"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedPoem.t) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedPoem.d) ? _c('p', {
    staticClass: "poem__desc"
  }, [_vm._v(_vm._s(_vm.selectedPoem.d))]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "poem__blocks",
    style: ({
      columnRuleColor: _vm.theme.rule
    })
  }, [_vm._v(_vm._s(_vm.selectedPoem.s))])] : _vm._e(), _vm._v(" "), _c('loading', {
    staticClass: "loading",
    attrs: {
      "color": _vm.theme.accent
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "poem__author"
  }, [_vm._v("—Traian Dorz")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "poem__url",
    attrs: {
      "id": "currentURL"
    }
  }, [_vm._v(_vm._s(_vm.currentURL))])], 2)]), _vm._v(" "), (_vm.$store.state.folderListDownloaded) ? _c('div', {
    staticClass: "button-prev",
    on: {
      "click": _vm.prevPoem
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconPrev"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.folderListDownloaded) ? _c('div', {
    staticClass: "button-next",
    on: {
      "click": _vm.nextPoem
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconNext"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "poem__share",
    style: ({
      backgroundColor: _vm.theme.background
    })
  }, [_c('svg', {
    staticClass: "icon icon-copy",
    attrs: {
      "data-clipboard-target": "#poem",
      "id": "btnCopy",
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.enableSelect
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
    }
  })]), _vm._v(" "), (_vm.navigatorHasShare) ? _c('svg', {
    staticClass: "icon icon-share-toggle",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.toggleShareMenu
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(_vm.$store.state.copyConfirmShown) ? _c('div', {
    staticClass: "copy-confirm",
    style: ({
      backgroundColor: _vm.theme.confirm,
      color: _vm.theme.confirm2
    })
  }, [_c('span', [_vm._v("Copiat")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "poem__zoom",
    style: ({
      backgroundColor: _vm.theme.background
    })
  }, [_c('transition', {
    attrs: {
      "name": "slide-zoom-3"
    }
  }, [(_vm.zoomMenuOpen) ? _c('svg', {
    staticClass: "icon icon-zoom",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.zoomReset
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-zoom-2"
    }
  }, [(_vm.zoomMenuOpen) ? _c('svg', {
    staticClass: "icon icon-zoom",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-zoom-1"
    }
  }, [(_vm.zoomMenuOpen) ? _c('svg', {
    staticClass: "icon icon-zoom",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('svg', {
    staticClass: "icon icon-zoom-toggle",
    class: {
      toggled: _vm.zoomMenuOpen
    },
    attrs: {
      "fill": _vm.zoomMenuOpen ? _vm.theme.accent : _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.toggleZoomMenu
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar-left"
  }, [_c('div', {
    staticClass: "sidebar-left__inner"
  }, [_c('div', {
    staticClass: "sidebar-left__top",
    style: ({
      borderRightColor: _vm.theme.border2,
      borderBottomColor: _vm.theme.border,
      backgroundColor: _vm.theme.navbar
    })
  }, [_c('svg', {
    staticClass: "icon icon-list",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    },
    on: {
      "click": _vm.toggleSidebarLeft
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconList"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-left__list",
    style: ({
      color: _vm.theme.text2,
      backgroundColor: _vm.theme.background,
      borderColor: _vm.theme.border3
    })
  }, [_vm._l((_vm.folderListSnap), function(folder, index) {
    return _c('div', {
      key: index,
      staticClass: "folder"
    }, [_c('input', {
      staticClass: "folder__radio",
      attrs: {
        "type": "radio",
        "id": ("folder" + index),
        "name": "folder"
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "folder__title",
      attrs: {
        "for": ("folder" + index)
      },
      on: {
        "click": function($event) {
          return _vm.handleFolderClick(("folder" + index))
        }
      }
    }, [_c('svg', {
      staticClass: "icon-caret",
      attrs: {
        "fill": _vm.theme.icon2,
        "width": "24",
        "height": "24"
      }
    }, [_c('use', {
      attrs: {
        "href": "#iconCaret"
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "icon-folder",
      attrs: {
        "fill": _vm.theme.accent,
        "width": "24",
        "height": "24"
      }
    }, [_c('use', {
      attrs: {
        "href": "#iconCaiet"
      }
    })]), _vm._v("\n          " + _vm._s(folder.t) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "poems",
      style: ({
        color: _vm.theme.text2
      })
    }, _vm._l((folder.p), function(poem) {
      return _c('router-link', {
        key: ("" + (poem.n)),
        attrs: {
          "id": ("" + (poem.n)),
          "to": {
            name: 'Poem',
            params: {
              nr: +poem.n,
              title: _vm.formatTitle(poem.t)
            }
          }
        }
      }, [_c('span', {
        staticClass: "link-span",
        on: {
          "click": _vm.tapPoemLink
        }
      }, [_c('span', {
        staticClass: "link-span__nr"
      }, [_vm._v(_vm._s(poem.n))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(poem.t))])])])
    }), 1)])
  }), _vm._v(" "), _c('loading', {
    staticClass: "loading",
    attrs: {
      "color": _vm.theme.accent
    }
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out"
  }, [_c('pre', {
    staticClass: "out__text",
    style: ({
      color: _vm.theme.accent
    })
  }, [_vm._v("  Tot ce v-am spus aici cu lacrimi\n  e adevăr curat şi greu\n  mărturisit pe conştiinţă\n  şi-n Numele lui Dumnezeu\n\n  Nu-mi lepădaţi nici o frîntură\n  din tot ce spun acum şi scriu\n  că tot ce nu-nţelegeţi astăzi\n  o să-nţelegeţi mai tîrziu.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "out-next",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconNext"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    style: ({
      color: _vm.selectedTheme.text,
      backgroundColor: _vm.selectedTheme.background,
      borderColor: _vm.selectedTheme.border
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('svg', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('symbol', {
    attrs: {
      "id": "iconList",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCaiet",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCaret",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m 9.5,17.5 5,-5 -5,-5 z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconSearch",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCheck",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconCheckOn",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconPrev",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "iconNext",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backdrop"
    }
  }, [(_vm.$store.state.sidebarLeftToggled || _vm.$store.state.sidebarRightToggled) ? _c('div', {
    staticClass: "backdrop backdrop--sidebar",
    style: ({
      backgroundColor: _vm.selectedTheme.backdrop
    }),
    on: {
      "click": _vm.closeSidebars
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar-slide-left"
    }
  }, [_c('sidebar-left', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.sidebarLeftToggled),
      expression: "$store.state.sidebarLeftToggled"
    }],
    attrs: {
      "folderListSnap": _vm.folderListSnap,
      "theme": _vm.selectedTheme
    }
  })], 1), _vm._v(" "), _c('main', {
    staticClass: "app__main",
    style: ({
      backgroundColor: _vm.selectedTheme.background2
    })
  }, [_c('navbar', {
    attrs: {
      "theme": _vm.selectedTheme,
      "themes": _vm.themes
    },
    on: {
      "downloadFolderList": _vm.getFolderListSnap,
      "downloadPoems": _vm.getPoemsSnap
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-view",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "app__main-view",
    attrs: {
      "selectedPoem": _vm.selectedPoem,
      "theme": _vm.selectedTheme
    },
    on: {
      "downloadFolderList": _vm.getFolderListSnap,
      "downloadPoems": _vm.getPoemsSnap
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar-slide-right"
    }
  }, [_c('sidebar-right', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.sidebarRightToggled),
      expression: "$store.state.sidebarRightToggled"
    }],
    attrs: {
      "poemsSnap": _vm.poemsSnap,
      "theme": _vm.selectedTheme
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backdrop"
    }
  }, [(_vm.$store.state.moreOpen) ? _c('div', {
    staticClass: "backdrop",
    style: ({
      backgroundColor: _vm.selectedTheme.backdrop
    }),
    on: {
      "click": _vm.toggleMore
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backdrop"
    }
  }, [(_vm.$store.state.moreOpen) ? _c('more', {
    attrs: {
      "theme": _vm.selectedTheme
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar-right"
  }, [_c('div', {
    staticClass: "sidebar-right__inner"
  }, [(_vm.poemsSnap) ? _c('form', {
    staticClass: "search-box",
    style: ({
      borderLeftColor: _vm.theme.border2,
      borderBottomColor: _vm.theme.border,
      backgroundColor: _vm.theme.navbar
    }),
    on: {
      "click": _vm.focusSearch,
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitSearch($event)
      }
    }
  }, [_c('svg', {
    staticClass: "search-box__icon",
    attrs: {
      "fill": _vm.$store.state.searchFocused ? _vm.theme.accent : _vm.theme.icon,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconSearch"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "search-box__input",
    style: ({
      color: _vm.theme.text3
    }),
    attrs: {
      "id": "searchInput",
      "type": "search",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false",
      "placeholder": "Caută"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "focus": function($event) {
        return _vm.handleSearchFocus(true)
      },
      "blur": function($event) {
        return _vm.handleSearchFocus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__main",
    style: ({
      backgroundColor: _vm.theme.background,
      borderColor: _vm.theme.border3
    })
  }, [(_vm.poemsSnap) ? _c('div', {
    staticClass: "sidebar-right__filters"
  }, [_c('div', {
    staticClass: "sidebar-right__filters-icon-wrapper",
    style: ({
      backgroundColor: _vm.theme.background,
      borderColor: !_vm.$store.state.filtersOpen ? '' : 'transparent'
    })
  }, [_c('svg', {
    staticClass: "icon icon-filters",
    attrs: {
      "fill": !_vm.$store.state.filtersOpen ? _vm.theme.icon2 : _vm.theme.accent,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.toggleFilters
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "results-info"
  }, [_vm._v(_vm._s(_vm.resultsInfo))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "filters"
    }
  }, [(_vm.$store.state.filtersOpen) ? _c('div', {
    staticClass: "sidebar-right__filter-wrapper",
    style: ({
      color: _vm.theme.text2
    })
  }, [_c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxTitle",
      "id": "checkboxTitle"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxTitle") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxTitle",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxTitle"
    },
    on: {
      "click": _vm.handleCheckTitle
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("În titlu")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxVerses",
      "id": "checkboxVerses"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxVerses") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxVerses",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxVerses"
    },
    on: {
      "click": _vm.handleCheckVerses
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("În versuri")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxWhole",
      "id": "checkboxWhole"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxWhole") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxWhole",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxWhole"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Cuvinte întregi")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxCase",
      "id": "checkboxCase"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxCase") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxCase",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxCase"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Ignoră majusculele")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxAccents",
      "id": "checkboxAccents"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxAccents") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxAccents",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxAccents"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Ignoră diacriticele")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedFilters),
      expression: "checkedFilters"
    }],
    attrs: {
      "type": "checkbox",
      "value": "checkboxPunctuation",
      "id": "checkboxPunctuation"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedFilters) ? _vm._i(_vm.checkedFilters, "checkboxPunctuation") > -1 : (_vm.checkedFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkedFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkboxPunctuation",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxPunctuation"
    }
  }, [_c('svg', {
    staticClass: "icon icon-check",
    attrs: {
      "fill": _vm.theme.accent,
      "width": "24",
      "height": "24"
    }
  }, [_c('use', {
    staticClass: "off",
    attrs: {
      "href": "#iconCheck"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "on",
    attrs: {
      "href": "#iconCheckOn"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Ignoră semnele de punctuație")])])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-right__results",
    attrs: {
      "id": "sidebarRightResults"
    }
  }, _vm._l((_vm.results), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "result",
      attrs: {
        "id": ("res" + (result.nr))
      },
      on: {
        "click": function($event) {
          return _vm.handleResultClick($event, result.nr)
        }
      }
    }, [_c('span', {
      staticClass: "result__nr"
    }, [_vm._v(_vm._s(result.nr))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "result__title",
      domProps: {
        "innerHTML": _vm._s(result.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "result__verses"
    }, _vm._l((result.verses), function(verse, verseIndex) {
      return _c('div', {
        key: verseIndex,
        staticClass: "result__verse",
        domProps: {
          "innerHTML": _vm._s(verse)
        }
      })
    }), 0)])])
  }), 0), _vm._v(" "), (!_vm.poemsSnap) ? _c('loading', {
    staticClass: "loading",
    attrs: {
      "color": _vm.theme.accent
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', [_c('div', {
    staticClass: "landing-intro"
  }, [_c('img', {
    staticClass: "landing-img",
    style: ({
      color: _vm.theme.accent
    }),
    attrs: {
      "src": __webpack_require__(117),
      "alt": "Traian Dorz"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "landing__header",
    style: ({
      color: _vm.theme.accent
    })
  }, [_c('div', [_vm._v("Slăvit")]), _vm._v(" "), _c('div', [_vm._v("să fie")]), _vm._v(" "), _c('div', [_vm._v("Domnul")])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-info"
  }, [_c('p', {
    staticClass: "landing-text"
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    style: ({
      color: _vm.listButtonHovered ? _vm.theme.background : _vm.theme.accent,
      backgroundColor: _vm.listButtonHovered ? _vm.theme.accent : ''
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebarLeft,
      "mouseenter": function($event) {
        _vm.listButtonHovered = true
      },
      "mouseleave": function($event) {
        _vm.listButtonHovered = false
      }
    }
  }, [_vm._v("\n        Cuprins\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    style: ({
      color: _vm.searchButtonHovered ? _vm.theme.background : _vm.theme.accent,
      backgroundColor: _vm.searchButtonHovered ? _vm.theme.accent : ''
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebarRight,
      "mouseenter": function($event) {
        _vm.searchButtonHovered = true
      },
      "mouseleave": function($event) {
        _vm.searchButtonHovered = false
      }
    }
  }, [_vm._v("\n        Căutare\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theme-picker"
  }, _vm._l((_vm.themes), function(theme, index) {
    return _c('div', {
      key: index,
      staticClass: "swatch",
      style: ({
        backgroundColor: theme.background
      }),
      on: {
        "click": function($event) {
          return _vm.setSelectedTheme(index)
        }
      }
    }, [(index === _vm.$store.state.selectedTheme) ? _c('svg', {
      staticClass: "swatch__check",
      attrs: {
        "fill": theme.accent,
        "height": "24",
        "width": "24"
      }
    }, [_c('use', {
      attrs: {
        "href": "#iconCheckOn"
      }
    })]) : _vm._e()])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out"
  }, [_c('pre', {
    staticClass: "out__text",
    style: ({
      color: _vm.theme.accent
    })
  }, [_vm._v("  Slăvit să fie Domnul\n  căci El ne-a dăruit\n  Lumina şi-Ajutorul\n  s-ajungem la sfîrşit.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "out-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconPrev"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('svg', {
    attrs: {
      "width": "200",
      "height": "2",
      "viewBox": "0 0 200 2"
    }
  }, [_c('line', {
    staticClass: "line",
    attrs: {
      "stroke": _vm.color,
      "x1": "0",
      "y1": "1",
      "x2": "200",
      "y2": "1",
      "stroke-width": "2"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar",
    style: ({
      backgroundColor: _vm.theme.navbar,
      borderColor: _vm.theme.border
    })
  }, [_c('div', {
    staticClass: "navbar__icons-left"
  }, [_c('div', {
    staticClass: "navbar__icons-toggle navbar__icons-toggle--left",
    class: {
      toggled: _vm.$store.state.sidebarLeftToggled
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.sidebarLeftToggled),
      expression: "$store.state.sidebarLeftToggled"
    }],
    staticClass: "icon icon-list-arrow",
    attrs: {
      "fill": _vm.theme.icon,
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": _vm.toggleSidebarLeft
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0-.5h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.state.sidebarLeftToggled),
      expression: "!$store.state.sidebarLeftToggled"
    }],
    staticClass: "icon icon-list",
    attrs: {
      "fill": _vm.theme.icon,
      "width": "24",
      "height": "24"
    },
    on: {
      "click": _vm.toggleSidebarLeft
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconList"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "icon icon-more",
    attrs: {
      "fill": _vm.$store.state.moreOpen ? _vm.theme.accent : _vm.theme.icon,
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": _vm.toggleMore
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/",
      "title": "Acasă"
    }
  }, [_c('svg', {
    staticClass: "logo__img",
    attrs: {
      "fill": _vm.theme.logo,
      "width": "28.222mm",
      "height": "12.848mm",
      "viewBox": "0 0 99.999878 45.523945"
    }
  }, [_c('path', {
    attrs: {
      "d": "m4.4706 0.010515c-0.7248-0.036748-1.4452 0.017118-2.1606 0.25268-3.2301 3.0225 2.4917 2.1602 3.5559 3.4882-0.9796 2.4305-0.6218 5.9924 0.4065 8.1666-1.0076 2.548-6.9372-2.3498-6.2109 1.196 3.0288 1.619 4.9062 4.933 7.7929 6.666 2.7296-0.057 0.2976-5.13 1.1554-6.974-1.6619-1.523-2.9815-5.3041-2.0727-7.3902 2.6426 2.388 1.3057-0.9272 0.3003-2.1533 1.5626-2.7021 6.0976-0.335 8.8626-0.4047 2.651-1.8989-3.184-3.5078-5.049-2.4463-2.1969 0.6432-4.4059-0.29074-6.5804-0.40098zm45.077 1.0895c-1.7359 1.7578 0.99702 5.7599 2.3749 7.3865 0.50366 0.14225 1.1 0.00835 1.4557-0.38818 0.21053-2.3895-0.70801-6.9613-3.8306-6.9983zm-14.046 4.0778c-2.4237-0.037344-4.743 2.6847-5.993 4.7168-2.3236 2.011-5.5478 9.0812-8.4265 4.0338-1.4414-2.6734-3.048-9.2281-7.1832-7.0404-3.5393 2.4903 0.05814 7.321 2.8143 8.7305 3.4824-1.0762-3.8236-4.0258-2.7173-6.5479 3.567-2.6751 4.3614 3.9796 5.7605 5.993 1.6406 4.0904 5.254 0.92708 8.0054 1.2231 1.6868 2.481 5.3074 1.5105 6.9708-1.1627 2.1426 0.02405 2.9675 3.6101 5.8337 2.1222 3.7757 0.9622 5.9436-3.5868 9.7449-3.0487 1.2906 2.1326 4.521 4.2965 6.319 1.9006 2.5412-1.5281 4.2927-0.27918 6.9324-0.50537 3.3071-0.76221 4.8975 1.9788 7.2327 3.5284 0.29757 0.61069 1.3359-0.03027 1.6022-0.37537 2.8774-2.4732 6.1533-4.6541 7.5165-8.3917 2.5793-3.8484 3.2025 3.6351 4.0613 5.2496 1.9522 5.0098 3.8457-1.3895 4.986-3.4442 1.7933 0.23953 2.7966 5.5368 6.1963 3.5284 1.6233 0.59099 7.3917-2.4337 3.5431-2.8107-3.0298 0.8803-6.9362 0.98698-7.2437-3.0743-2.5583-4.8738-4.2351 3.6072-6.2183 2.8125-0.76138-2.4366-1.4116-7.3579-4.9091-6.5222-3.0467 2.0009-4.6249 5.4873-6.4618 8.5162-1.4771 4.6444-6.6571 0.64481-4.5923-2.655 2.2809-2.3056-1.2748-6.0341-3.8031-6.2073-5.1458-1.3161-5.6343 4.3988-6.6595 7.8607-2.2348 2.6321-6.688 2.1865-6.9672-1.7651 0.41578-3.3646-2.4466-2.301-3.9001-0.6189-2.5908 2.0332-5.44 5.2161-9.0912 4.0503-4.3345-1.759-0.5749-6.205-0.93018-9.0125-0.79502-0.75352-1.6146-1.0715-2.4225-1.084zm-0.60608 2.1661c4.4954-0.12313-1.1241 2.4531-2.1588 3.6346l-0.39917 0.48706c-2.2541-0.01584 1.61-3.3535 2.558-4.1217zm29.264 0.74524c0.19471-0.014814 0.39405-0.00392 0.59509 0.032959 5.3691 0.40354 0.82342 4.6613-1.6846 5.6873-3.8722 0.16435-1.8311-5.498 1.0895-5.7202zm-30.239 3.1859c0.62986 0.0047-0.54107 2.453-1.6589 3.1384-3.111 3.3874-1.3878-1.5597 0.36072-2.1735 0.67828-0.69766 1.0883-0.96653 1.2982-0.96497zm-27.995 2.741c0.8454-0.008 2.0185 0.765 1.1609 2.062-0.3542 0.501-1.1496-0.295-1.4264-0.507-0.8513-1.07-0.392-1.548 0.2655-1.555zm15.654 6.3116c-2.0981 0.15926-1.3227 3.5328-0.26001 5.1086 0.91864 2.4633 1.4271 5.1365 1.6058 7.7618-0.96561 1.492-5.0793-0.63763-4.9713 2.0013 1.7292 1.2754 3.361 2.7414 5.2185 3.858 2.2723 0.90501 4.473 3.1772 7.0825 2.005 2.3839-0.99136 0.7709-4.0483 0.63354-5.9564 0.54016-1.6156 4.6402-2.7615 4.7314-0.36987-0.13728 2.3238 0.16056 4.6916 2.6221 5.7074 1.6005 1.864 4.8029 1.4801 6.3684-0.32959 2.5163-1.5503 1.3859-4.5115 1.5894-6.9086 0.16634-1.9775 1.2191-0.65614 1.767 0.29297 1.994 1.9594 0.16239-1.767 1.0986-2.005 1.695-1.2487 4.1269 0.80027 3.3527 2.71-0.66768 1.551 1.2307 5.1641 2.5616 3.0432-0.13438-2.4472-1.0619-5.2128 0.97229-7.132 0.87171-2.3896 3.3787 0.47367 5.1746-0.2124 2.0973 0.19657 4.1234-0.25924 6.1688-0.58777 2.4034-0.29238 0.17118 4.4105-1.0217 2.9407-1.9702-1.8381-2.6858 0.40086-2.0819 2.1039 2.332-1.0053 2.3789 1.0349 1.1169 2.4719-1.5714 1.2944-1.4151 3.6808-2.5012 5.0189-0.42615-1.3751-1.7228-2.2578-3.2446-2.4353-1.3326 1.1338 0.12847 4.008 0.15747 5.7074 0.59709 0.38702 1.447 0.11014 2.1057 0.02014 0.93017-1.8241 2.7384-0.33253 3.7189-0.17212 1.1368 0.18599 2.5076 0.45123 3.6621 0.53833 1.1545 0.08716 2.0069-0.15948 1.6315-1.6919 0.81718-1.5389-1.3097-2.2468-1.3403-0.61523-1.4279 1.9952-6.5362 0.22935-4.6252-2.3273 1.5977-1.5123 1.3526-4.5162 3.327-5.4163 2.2851-0.20354 4.5992 0.27058 6.8829 0.44678 1.4478 0.94041 5.3438-0.768 2.6093-1.9464-2.0745 0.21907-4.1472 0.40931-6.2457 0.44861-2.785 0.54568-2.8503-2.7049-0.7727-3.717 1.2478-2.114 5.5264-1.0671 5.2625-4.0008-1.4598-1.8212-4.0087 0.24205-5.6451 0.92651-2.8274 0.8588-5.8702 1.0204-8.8184 0.89722-2.5118 0.73723-3.4652-2.9158-5.7477-1.8988-0.9233 2.5898-3.8851 1.8119-5.9619 2.7191-1.9229 1.9892-4.2122 1.4051-6.3831 0.19226-2.7219-0.88055-5.1632 1.1465-7.6556 1.7926-2.0128-0.28561-5.8297 2.9256-6.5039-0.11353-0.51064-2.1888-1.0468-4.5498-2.6477-6.2238-1.3002-1.4938-2.8458-2.9745-3.9093-4.5099-0.42449-0.12305-0.78426-0.16557-1.084-0.14282zm0.32044 2.1387c1.6997 0.94243 3.0149 3.1471 4.14 4.8541 0.97398 1.7655 2.6055 3.6755 2.3492 5.766-0.87232 0.39508-2.2376 0.40074-3.1421 0.08972-0.25881-1.7104 0.60868-3.6247-0.30945-5.3503-0.15164-2.2565-3.9192-3.1181-3.0377-5.3595zm20.131 7.8442c1.2828-0.02295 2.643 1.1167 3.0688 2.3364-0.43799 1.8418 0.79429 4.313-0.84778 5.6635l-0.12268 0.23254c-1.4617 1.2305-5.9565 0.73682-5.3888-1.9318 1.4167-1.978-1.1876-4.6703 1.6846-5.4474 0.45619-0.5935 1.0227-0.84284 1.6058-0.85327zm-13.66 4.2224c1.841 0.16587 2.3026 4.4886 0.65369 5.1727-1.0738 0.25872-2.0984-0.10486-2.9846-0.69397-1.3101-1.3586-4.5183-1.665-4.6234-3.4772 1.9912-0.5453 4.0662 0.04575 6.0828-0.79468 0.31724-0.16866 0.60858-0.2306 0.87158-0.20691zm8.9374 0.0824c0.33232-0.01231 0.63434 0.72002 0.32776 1.5417 0.56461 3.1806-1.5429 1.1129-0.83313-0.57312 0.09538-0.68607 0.30598-0.96124 0.50537-0.96863zm3.9294 5.0922c0.06596-0.01762 0.16635 0.01998 0.29846 0.17029-0.39545 0.43962-0.49635-0.11746-0.29846-0.17029zm19.479 2.3712c0.10455-0.01778 0.22563 0.0019 0.36621 0.07325 0.5623 0.28548 1.1055 1.0381 0.60425 1.6699-0.27977 0.3313-0.6495 0.43418-0.93018 0.33508-0.28069-0.09906-0.47652-0.96961-0.49072-1.2891-0.01533-0.34507 0.1368-0.73583 0.45044-0.78918z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar__icons-right"
  }, [(_vm.themePickerToggled) ? _c('div', {
    staticClass: "backdrop backdrop--picker",
    on: {
      "click": _vm.closeThemePicker
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon-picker-wrapper"
  }, [_c('svg', {
    staticClass: "icon icon-picker",
    class: {
      toggled: _vm.themePickerToggled
    },
    attrs: {
      "fill": _vm.themePickerToggled ? _vm.theme.accent : _vm.theme.icon,
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": _vm.toggleThemePicker
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.theme.accent,
      "d": "M0 20h24v4H0z"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "theme-picker"
    }
  }, [(_vm.themePickerToggled) ? _c('theme-picker', {
    attrs: {
      "themes": _vm.themes
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar__icons-toggle navbar__icons-toggle--right",
    class: {
      toggled: _vm.$store.state.sidebarRightToggled
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.sidebarRightToggled),
      expression: "$store.state.sidebarRightToggled"
    }],
    staticClass: "icon icon-search-arrow",
    attrs: {
      "fill": _vm.theme.icon,
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": _vm.toggleSidebarRight
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0-.25h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.state.sidebarRightToggled),
      expression: "!$store.state.sidebarRightToggled"
    }],
    staticClass: "icon icon-search",
    attrs: {
      "fill": _vm.theme.icon,
      "width": "24",
      "height": "24"
    },
    on: {
      "click": _vm.toggleSidebarRight
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconSearch"
    }
  })])])])], 1)
},staticRenderFns: []}

/***/ })
]),[48]);


// WEBPACK FOOTER //
// static/js/app.80d8ece0cd23b988fe97.js